<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="10" sm="8" md="6" class="text-center">
        <v-img src="@/assets/image/images-mail@3x.png" :width="imageWidth" class="mx-auto mb-5"></v-img>
        <div class="text-huge-title font-weight-bold">{{ $t('send_email_title') }}</div>
        <div class="mt-5 text-title font-weight-bold" v-html="$t('send_email_content', { mail: email })">
        </div>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="10" sm="6" md="4">
        <v-btn color="primary" outlined depressed block x-large class="mt-2 font-weight-bold" style="border: 3px solid;"
          :disabled="!loadingFinished" @click="sendVerify">
          <template v-if="!loadingFinished">
            <v-progress-circular indeterminate color="grey" size="25" width="2"></v-progress-circular>
          </template>
          <template v-else>
            {{ $t('send_email_try_again') }}
          </template>
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </div>
</template>

<script>
import UM from "@/api/user-management";
import { mapActions } from "vuex";

export default {
  props: {
    email: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loadingFinished: true
    };
  },
  computed: {
    mailConent() {
      return this.$t('send_email_content', { mail: this.email });
    },
    imageWidth() {
      if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm)
        return "100";
      else return "120";
    }
  },
  methods: {
    ...mapActions({
      showDialog: "dialog/show"
    }),
    async sendVerify() {
      this.loadingFinished = false;
      const { data } = await UM.sendEmailVerify();
      if (data.errCode === "00")
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
              <img
                src="/image/ic-success@3x.png"
                alt=""
                style="width:80px"
              />
              <div class="mt-5">${this.$t('send_email_submit_success')}</div>
            </div>`
        });
      else {
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
              <img
                src="/image/ic-warning@3x.png"
                alt=""
                style="width:80px"
              />
              <div class="mt-5">${this.$t('send_email_submit_fail')}<br>${data.errDetail}</div>
            </div>`
        });
        console.log(
          `發送失敗\nerrCode: ${data.errCode}\nerrMsg: ${data.errMsg
          }\nerrDetail: ${data.errDetail}`
        );
      }

      this.loadingFinished = true;
    }
  }
};
</script>
